import { useState, useEffect } from 'react';
import { BASE_URL, getAllCustomerDataByCID, getCustomerData, getSalesPerfomerDetailsList, getSalesPerfomerDetailsReportList, downloadSalesPerformerReportCsv, fetchZonesPOReports } from 'Service/ApiService';

const API_URL = BASE_URL+'salesPerfomerReport.php';

const SalesPerformanceReportController = () => {
  const [data, setData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(0); // TablePagination 0-based
  const pageSize = 100;

  // Filters
  const [customerOptions, setCustomerOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [selectedCustomerOption, setSelectedCustomerOption] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [selectedSPId, setSelectedSPId] = useState('');
  const [detailRows, setDetailRows] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    loadCustomers('');
    loadZones();
  }, []);

  const loadZones = async () => {
    try {
      const response = await fetchZonesPOReports(user.userCode, 'sales');
      if (response?.status && Array.isArray(response.zones)) {
        setZoneOptions(
          response.zones.map((z, idx) => ({
            value: `${z.zoneCode}_${idx}`,
            label: z.region?.trim() || z.zoneName?.trim() || z.zoneCode,
            zoneCode: z.zoneCode
          }))
        );
      } else {
        setZoneOptions([]);
      }
    } catch (err) {
      console.error('Zone load error:', err);
      setZoneOptions([]);
    }
  };

  const loadCustomers = async (searchText) => {
      try {
        const response = await getCustomerData(user.userCode,searchText);
        if (response?.success === 'true') {
           const uniqueCustomers = [
            ...new Map(
              response.customerList.map((item) => [
                item.partyCode,
                {
                  value: item.partyCode.toString(),
                  label: `${item.partyName} - ${item.partyCode}`
                }
              ])
            ).values()
          ];

          setCustomerOptions(uniqueCustomers);
        }
      } catch (err) {
        console.error(err);
      }
    };

  useEffect(() => {
    const fetchReport = async () => {
      setcLoading(true);
      try {
        const payload = new URLSearchParams();
        // API expects 1-based page
        payload.append('page', String(page + 1));
        payload.append('pageSize', String(pageSize));
        payload.append('userCode', user?.userCode || '');
        payload.append('customerCode', selectedCustomerOption?.value || '');
        payload.append('fromDate', fromDate || '');
        payload.append('toDate', toDate || '');

        const res = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: payload.toString()
        });

        const json = await res.json();
        if (json && (json.success === true || json.success === 'true')) {
          setData(Array.isArray(json.data) ? json.data : []);
          setTotalRecords(Number(json.totalRecords) || 0);
        } else {
          setData([]);
          setTotalRecords(0);
        }
      } catch (err) {
        console.error(err);
        setData([]);
        setTotalRecords(0);
      } finally {
        setcLoading(false);
      }
    };

    fetchReport();
  }, [page, selectedCustomerOption, fromDate, toDate]);

  const handleClearFilters = () => {
    setSelectedCustomerOption(null);
    setFromDate('');
    setToDate('');
    setPage(0);
  };

  const handleDownloadReport = async () => {
    setDownloadLoading(true);
    try {
      await downloadSalesPerformerReportCsv(selectedCustomerOption?.value || '', fromDate || '', toDate || '', user.userCode);
    } catch (err) {
      console.error(err);
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleOpenDetails = async (salesPerformerId) => {
    setSelectedSPId(salesPerformerId);
    setDetailDialogOpen(true);
    setDetailLoading(true);
    try {
      const response = await getSalesPerfomerDetailsReportList(salesPerformerId);
      if (response?.success === 'true' || response?.success === true) {
        setDetailRows(Array.isArray(response.data) ? response.data : []);
      } else {
        setDetailRows([]);
      }
    } catch (err) {
      console.error(err);
      setDetailRows([]);
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCloseDetails = () => {
    setDetailDialogOpen(false);
    setDetailRows([]);
    setSelectedSPId('');
  };

  const searchCustomer = async (searchText) => {
     loadCustomers(searchText);
  }

  return {
    data,
    cloading,
    totalRecords,
    page,
    setPage,
    pageSize,
    customerOptions,
    searchCustomer,
    selectedCustomerOption,
    setSelectedCustomerOption,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    detailDialogOpen,
    selectedSPId,
    detailRows,
    detailLoading,
    downloadLoading,
    handleClearFilters,
    handleDownloadReport,
    handleOpenDetails,
    handleCloseDetails,
    zoneOptions
  };
};

export default SalesPerformanceReportController;
